import { render, staticRenderFns } from "./announcememt.vue?vue&type=template&id=7db2028a&scoped=true&"
import script from "./announcememt.vue?vue&type=script&lang=js&"
export * from "./announcememt.vue?vue&type=script&lang=js&"
import style0 from "./announcememt.vue?vue&type=style&index=0&id=7db2028a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db2028a",
  null
  
)

export default component.exports